import { memo } from 'react';

import type { TModalProps } from '~components/Modals/types';
import { Title } from '~components/Typography';
import { FeedbackCategory } from '~entities/feedback';
import { useTranslations } from '~i18n/hooks';
import { ReviewModal } from '~shared/ui/organisms/ReviewModal';
import { FeedbackForm } from '~widgets/FeedbackForm';

type Props = TModalProps;

export const ChatReview = memo(({ open, onClose }: Props) => {
	const t = useTranslations('Chats');

	return (
		<ReviewModal
			title={
				<Title size="M" align="left">
					{t('chatReviewModalTitle')}
				</Title>
			}
			subtitle={t('chatReviewModalSubtitle')}
			open={open}
			locked={true}
			onClose={onClose}
			data-name="chats-feedback-modal"
		>
			<FeedbackForm onSubmit={onClose} category={FeedbackCategory.Chats} />
		</ReviewModal>
	);
});

ChatReview.displayName = 'ChatReview';
